import React, { FC, createContext, useState, useEffect } from "react";
import config from "../../staticConfig";
import axios from "axios";
import { TypeNoteHistoryItem } from "../../types/TypeContact";

interface TypeContextNoteHistory {
  noteHistory: TypeNoteHistoryItem[];
  updateNoteHistoryList: any;
}

export const NoteHistoryContext = createContext<TypeContextNoteHistory>({
  noteHistory: [],
  updateNoteHistoryList: () => {},
});

export const NoteHistoryProvider: FC<{}> = ({ children }) => {
  const [noteHistory, setNoteHistory] = useState<TypeNoteHistoryItem[]>([]);

  const updateNoteHistoryList = (
    newNote: TypeNoteHistoryItem[],
    replace?: boolean
  ) => {
    if (replace) {
      setNoteHistory([...newNote]);
    } else {
      setNoteHistory([...newNote, ...noteHistory]);
    }
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const phone = url.searchParams.get("phone");
    if (Boolean(phone)) {
      (async () => {
        const phoneNumber = phone!.trim();
        const endpointUrl = `${config.apiGatewayEndpoint}/notesearch?phoneNumber=${phoneNumber}`;
        try {
          const response = await axios.get(endpointUrl);
          const filteredNotes = response.data.filter(
            (n: TypeNoteHistoryItem) => n.contactNotes && n.contactNotes !== ""
          );
          setNoteHistory(filteredNotes.reverse());
        } catch (error) {
          console.error("Retrieve note history error", error);
        }
      })();
    }
  }, []);

  return (
    <NoteHistoryContext.Provider
      value={{
        noteHistory,
        updateNoteHistoryList,
      }}
    >
      {children}
    </NoteHistoryContext.Provider>
  );
};
